<div class="hs-locate ol-unselectable ol-control hs-locateToggler" [hidden]="(isVisible$ | async) === false"
    [ngClass]="{'ol-collapsed': collapsed}">
    <button class="ol-has-tooltip blocate hs-locateToggler" [title]="'GEOLOCATION.locateMe' | translateHs"
        *ngIf="!getLocalization()" type="button" (click)="startLocalization()">
        <i class="glyphicon icon-gpsoff-gps hs-locateToggler"></i>
    </button>
    <button *ngIf="getLocalization()" class="ol-has-tooltip blocate hs-locateToggler hs-locationButton" type="button"
        (click)="toggleTracking()" [title]="'GEOLOCATION.locateMe' | translateHs" (dblclick)="stopLocalization()">
        <i class="glyphicon hs-locateToggler"
            [ngClass]="(isFollowing() && getLocalization()) ? 'icon-navigation' : 'icon-gpson'"></i><!-- TODO: Remove function call from template -->
    </button>
</div>